import { Row } from 'react-bootstrap';
import { Html } from '../Component/Commons';
export function Title({ data: { props: { color }, html } }:any) {
    return <Row className='m-0 p-0' style={{ background: color }}>
        <Html className="container" html={html} />
    </Row>
}